import React from 'react';

import { MessageMetaData, ThreadSummary } from 'flow/types/Chats';
import { useAppDispatch } from 'flow/hooks/useRedux';
import { openSelectedThreadMessage } from 'flow/actions/chat-actions';
import { twMerge } from 'tailwind-merge';
import Tooltip from 'flow/components/ui-components/Tooltip';
import useAppContext from 'flow/hooks/useAppContext';

interface ThreadMessageSummaryProps {
    threadSummary: ThreadSummary;
    keys: MessageMetaData;
    isThreadOpened: boolean;
}

const ThreadMessageSummary = ({
    threadSummary,
    keys,
    isThreadOpened,
}: ThreadMessageSummaryProps) => {
    const dispatch = useAppDispatch();
    const { i18next } = useAppContext();
    const { chatSessionKey, chatMessageKey } = keys;
    const messageCount = threadSummary?.messageCount;

    return messageCount > 0 ? (
        <button
            className={twMerge(
                'cursor relative my-2 rounded-sm border px-3 py-1 text-xs/4 font-medium',
                isThreadOpened
                    ? 'border-green bg-green/10 hover:bg-green/20'
                    : 'border-gray-300 hover:bg-gray-200',
            )}
            onClick={() =>
                dispatch(
                    openSelectedThreadMessage(chatSessionKey, chatMessageKey),
                )
            }
        >
            <span>
                {i18next.t('ThreadMessages.ReplyNumber', {
                    numReplies: messageCount,
                })}
            </span>
            {threadSummary?.unreadCount > 0 && (
                <Tooltip
                    label={i18next.t('ThreadMessages.UnreadReplies.Tooltip', {
                        unreadCount: threadSummary?.unreadCount,
                    })}
                    placement="bottom"
                >
                    <div className="bg-red text-2xs absolute -end-3 -top-2 flex size-5 items-center justify-center rounded-full font-bold text-white">
                        {threadSummary?.unreadCount}
                    </div>
                </Tooltip>
            )}
        </button>
    ) : null;
};

export default ThreadMessageSummary;
